/**
 * Pure helpers for persisting the floating assistant chat's layout.
 *
 * Kept dependency-free and separate from `chat-integration-floating` so the app
 * shell can read these without pulling in the whole assistant module graph
 * (which statically imports livekit-client → the ~698KB vendor-livekit chunk).
 */

export const LAYOUT_STORAGE_KEY = "pentacode:assistant-chat-layout";

const CSS_LENGTH_RE = /^-?\d+(\.\d+)?(px|%|em|rem|svw|svh|vw|vh)$/;

export function isCssLength(value: unknown): value is string {
    return typeof value === "string" && CSS_LENGTH_RE.test(value);
}

export function dockBubbleAnchor(rect: { left: number; bottom: number; width: number; height: number }): {
    x: number;
    y: number;
} {
    return { x: rect.left + rect.width / 2, y: rect.bottom - rect.width / 2 };
}
